const personalInfo = {
  resumeUrl:
    "https://docs.google.com/document/d/1TmwD27LbZbiUt1vMPTYgXDq8tdfRITfuG7oUsuggl-Y/export?format=pdf",
  phone: "+6282176854180",
  email: "jonathanchristopher1199@gmail.com",
  linkedin: "https://linkedin.com/in/jonathan-christopher-jakub/",
};

export default personalInfo;
